// CUÁNTO SE QUEDA UNA CITA EN PANTALLA. Eran seis segundos para todas, y Gabri pidió unos
// segundos más: que el lector, además de leerla, se quede un rato con la idea. Seis dan para
// leerla y para nada más.
//
// Y NO TODAS PUEDEN DURAR LO MISMO, que es el defecto que había debajo del número. «Ayúdame a
// hacerlo por mí mismo» son seis palabras y la de Freire son veinte: con un intervalo fijo, la
// corta se queda de sobra en pantalla y la larga se va justo cuando la estás acabando. El
// tiempo sale de la propia cita, y así ninguna lo hereda de otra.
//
// Sale entre diez y quince segundos. No es una pausa para meditar —esto aparece cuando el
// servidor no contesta, y nadie quiere quedarse a vivir aquí—: es leerla sin prisa y que
// todavía esté delante cuando levantas la vista.
const POSO = 8000;        // lo que se queda una cita DESPUÉS de leída, en milisegundos
const POR_PALABRA = 350;  // lo que cuesta una palabra de una frase que además hay que pensar

/** Los milisegundos que le tocan a esta cita. Una cita vacía o rara dura el poso y ya. */
export function duracionDe(cita) {
  const palabras = String(cita?.quote || "").trim().split(/\s+/).filter(Boolean).length;
  return POSO + palabras * POR_PALABRA;
}

export const RECOVERY_QUOTES = [
  {
    author: "Paulo Freire",
    quote: "Nadie educa a nadie, nadie se educa a sí mismo, los hombres se educan entre sí con la mediación del mundo.",
  },
  {
    author: "John Dewey",
    quote: "La educación no es preparación para la vida; la educación es la vida misma.",
  },
  {
    author: "Maria Montessori",
    quote: "Ayúdame a hacerlo por mí mismo.",
  },
  {
    author: "Seymour Papert",
    quote: "El arte de aprender a aprender depende en gran medida de nuestras actitudes hacia los errores.",
  },
  {
    author: "Lev Vygotsky",
    quote: "Lo que un niño puede hacer hoy con ayuda, podrá hacerlo mañana por sí solo.",
  },
  {
    author: "Jerome Bruner",
    quote: "Cualquier materia puede enseñarse de manera efectiva, de alguna forma honesta, a cualquier niño en cualquier etapa de su desarrollo.",
  },
  {
    author: "Edgar Morin",
    quote: "La reforma de la enseñanza debe conducir a la reforma del pensamiento, y la reforma del pensamiento debe conducir a la reforma de la enseñanza.",
  },
  {
    author: "Ken Robinson",
    quote: "La creatividad es tan importante en la educación como la alfabetización, y deberíamos tratarla con el mismo estatus.",
  },
  {
    author: "bell hooks",
    quote: "Enseñar es un acto performativo, es lo que otorga a nuestro trabajo su vitalidad.",
  },
];
